import styles from '../../CombinedLogs.module.scss'
import { flexRender, Table } from '@tanstack/react-table'
import clsx from 'clsx'
import { Log } from '@/types/logs'

export const TableFormPlaceholder = ({
    handleClick,
    isActive,
    table,
}: {
    handleClick: () => void
    isActive: boolean
    table: Table<Log>
}) => {
    return (
        <>
            {table.getHeaderGroups().map((headerGroup) => (
                <tr
                    onClick={handleClick}
                    className={clsx(styles.formRow, { [styles.hidden]: isActive })}
                    key={headerGroup.id}
                >
                    {headerGroup.headers.map((header) => (
                        <td
                            className={clsx(styles.placeholderFormCell, {
                                [styles.alignCenterFormCell]: header.column.columnDef.meta?.alignCenter,
                            })}
                            key={header.id}
                        >
                            {header.isPlaceholder || header.column.columnDef.meta?.isPlaceholder
                                ? header.column.columnDef.meta?.placeholder || null
                                : flexRender(header.column.columnDef.header, header.getContext())}
                        </td>
                    ))}
                </tr>
            ))}
        </>
    )
}
